module.exports = __webpack_public_path__ + "20ddd6eabec796899ad70f9904e47997.pdf";